import React from 'react';
import { Row, Col } from '@thd-olt-component-react/grid';
import { func, oneOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import * as analytics from '../analytics/analytics';
import '../../AugmentedReality.style.scss';

const ARContent = ({ assetLink, channel, forwardedRef, onClick }) => {
  const arClassName = classNames('augmented-reality__wrapper', {
    'augmented-reality__wrapper--desktop': channel !== 'mobile'
  });

  const handleOnClick = (clickEvent) => {
    analytics.track(clickEvent);
    if (onClick) {
      clickEvent.preventDefault();
      onClick(assetLink);
    }
  };

  const buttonLink = (
    <button ref={forwardedRef} className="augmented-reality__button" onClick={handleOnClick} type="button">
      <span className="augmented-reality__image">
        <img src="https://assets.homedepot-static.com/images/v1/AR-cube-darkgrey.svg" alt="" />
      </span>
      <span className="augmented-reality-button__prompt">
        <span className="augmented-reality__wrapper--view">See it in your home</span>
        <span> with 3D Augmented Reality</span>
      </span>
      <span className="augmented-reality__wrap--arrow" />

    </button>
  );

  return onClick ? buttonLink : (
    <a
      href={assetLink}
      rel="ar"
      className="augmented-reality__link"
      onClick={handleOnClick}
    >
      <img src="" alt="" aria-hidden="true" />
      <Row className={arClassName}>
        <Col>
          <span className="augmented-reality__image">
            <img src="https://assets.homedepot-static.com/images/v1/AR-cube-darkgrey.svg" alt="" />
          </span>
        </Col>
        <Col className="augmented-reality__text">
          <span>
            <span className="augmented-reality__wrapper--view">See it in your home</span>
            <div> with 3D Augmented Reality</div>
          </span>
        </Col>
        <Col className="augmented-reality__wrap">
          <span className="augmented-reality__wrap--arrow" />
        </Col>
      </Row>
    </a>
  );
};

ARContent.propTypes = {
  assetLink: string,
  channel: oneOf(['desktop', 'mobile']),
  forwardedRef: shape({}),
  onClick: func
};

ARContent.defaultProps = {
  assetLink: '',
  channel: 'desktop',
  forwardedRef: null,
  onClick: null
};

export { ARContent };
